<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-24 11:13:36
!-->
<template>
  <div id="index" class="index">
    <div class="header">
      <div class="left">
        <a href="/">
          <img src="../../assets/img/LOGO.png" width="180px" height="42px">
        </a>
      </div>
      <div class="right">
        <div><img src="../../assets/img/icon／语言／黑／未选中.png" width="24px" height="24px">
        </div>
        <!--未登录-->
        <div v-if="!isLogin" class="login-button">
          <button
            class="by-common--primary"
            @click="()=>{this.$store.commit('user/DIALOG_VISIBLE', true)}"
          >Login </button>
          <button
            class="by-button--primary"
            @click="()=>{
              this.$store.commit('user/STARTED_VISIBLE', true)}"
          >Start now</button>
        </div>
        <!--已登录-->
        <div v-if="isLogin" class="logind" @mouseover="navTopAtv = true" @mouseleave="navTopAtv = false">
          <div class="loginInfo" @click="goToManage">{{ customerInfo.firstWord }}</div>
          <el-collapse-transition>
            <div v-show="navTopAtv" class="topTipBox-login">
              <div class="navBoxSub-login">
                <div class="navBoxSub-first">
                  <div class="navBoxSub-left">{{ customerInfo.firstWord }}</div>
                  <div class="navBoxSub-right">
                    <div class="name">{{ customerInfo.customerName }}</div>
                    <div class="emil">{{ customerInfo.email }}</div>
                  </div>
                </div>
                <div class="line" />
                <div class="navBoxSub-two">
                  <div @click="goToManage('/shipments')">Shipments</div>
                  <!-- <div @click="goToManage()">Custom Quotes</div> -->
                  <div @click="goToManage('/billing')">Billing</div>
                </div>
                <div class="line" />
                <div class="navBoxSub-tree">
                  <div @click="goToManage('/produce')">My Settings</div>
                </div>
                <div class="line" />
                <div class="navBoxSub-four" @click="logout">Log out</div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetCurrCustomer,
  Logout
} from '../../api/user.js'
import {
  setCookie,
  getCookie,
  delCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: { // 组件的引用

  },
  props: { // 父辈向子辈传参
  },
  data() {
    return {
      navTopAtv: false,
      customerInfo: {},
      isLogin: false
    }
  },
  computed: { // 计算属性

  },
  watch: { // 监测变化

  },
  created() { // 实例被创建之后执行代码
    console.log('created')
    var that = this
    setTimeout(function() {
      var token = getCookie('token')
      if (token) {
        that.getCustomer()
      }
    }, 1000)
  },
  mounted() { // 页面进入时加载内容
    console.log('mounted')
  },
  methods: { // 方法
    goToManage(path) {
      if (!path) {
        path = `/manage`
      }
      const nativeHref = this.$router.resolve({
        path: path
        // query,
      })
      window.location.href = nativeHref.href
    },
    getCustomer() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          this.isLogin = true
          this.customerInfo = res.data
          this.customerInfo.firstWord = this.customerInfo.customerName.substring(0, 1)
		  setCookie('userInfo', JSON.stringify(res.data))
        }
      })
    },
    logout() {
      Logout().then(res => {
        if (res.code === 200) {
          this.isLogin = false
          delCookie('token')
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.index {
		.header {
			width: 1200px;
			height: 80px;
			text-align: center;
			margin: auto;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.right {
				display: flex;
				align-items: center;

				.login-button {
					display: flex;
					margin-left: 24px;

					button:nth-of-type(1) {
						width: 64px;
						height: 40px;
						margin-right: 8px;
						font-size: 16px;
					}

					button:nth-of-type(2) {
						width: 108px;
						height: 40px;
						font-size: 16px;
					}
				}

				.logind {
					.loginInfo {
						width: 32px;
						height: 32px;
						background: #EC6A24;
						border-radius: 20px;
						font-size: 18px;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						color: #FFFFFF;
						line-height: 32px;
						margin: 0 24px;
						cursor: pointer;

					}

					&:hover {
						.topTipBox-login {
							display: block;
							overflow: visible !important;
						}
					}

					.topTipBox-login {
						display: block;
						position: absolute;
						z-index: 999;
						width: 240px;
						height: 306px;

						.navBoxSub-login {
							top: 8px;
							position: relative;
							left: -182px;
							background: #FFFFFF;
							box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.16);
							border-radius: 8px;
							border: 1px solid rgba(221, 221, 221, 0.56);
							padding: 16px;
							text-align: left;

							.line {
								width: 208px;
								height: 1px;
								background: #EEEEEE;
								text-align: center;
								margin: 8px 0;
							}

							.navBoxSub-first {
								display: flex;

								.navBoxSub-left {
									@extend .loginInfo;
									width: 40px;
									height: 40px;
									margin: 0 8px 0 0;
									font-size: 23px;
									line-height: 40px;
									text-align: center;
								}

								.navBoxSub-right {
									text-align: left;

									.name {
										font-size: 16px;
										font-family: PingFangSC, PingFang SC;
										font-weight: 500;
										color: #333333;
									}

									.emil {
										font-size: 13px;
										font-family: PingFangSC, PingFang SC;
										font-weight: 400;
										color: #777777;
									}
								}

							}

							.navBoxSub-two,
							.navBoxSub-tree {
								font-size: 16px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								color: #333333;

								div {
									padding: 8px 0;
									cursor: pointer;
								}
							}

							.navBoxSub-four {
								font-size: 13px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								color: #777777;
								padding: 8px;
								text-align: left;
								cursor: pointer;
							}
						}

					}
				}
			}
		}
	}
</style>
